export default __webpack_public_path__ + "static/media/menu-exchangeWhite.0c4671e4.svg";